import React, { useEffect, useState } from "react";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import SimpleLoader from "../../components/Loader/SimpleLoader";
import VideoCard from "./VideoCard";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";

const ErkinOiyn = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await searchFilesByModule({ module_code: "erkin_oiyn" });
        const valid = res?.files?.filter((file) => !!file.link);
        setVideos(valid || []);
      } catch (err) {
        console.error(err);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    };

    fetchVideos();
  }, []);

  const filteredVideos = videos.filter((v) =>
    v.label?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className=" flex justify-center items-center">
        <SimpleLoader className="w-12 h-12 text-[#674da2] my-10" />
      </div>
    );
  }

  return (
    <div className="">
      <div className="p-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold mb-3 bg-[#674da2] bg-clip-text text-transparent">
            Еркін ойындар
          </h1>
          <p className="text-[#674da2] max-w-2xl mx-auto">
            Балаларға арналған еркін ойын жаттығулары
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-8 flex justify-center">
          <div className="relative w-full max-w-md">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Іздеу: видео атауы..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-[#674da2]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Videos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredVideos.map((video, index) => (
            <VideoCard key={video.uuid} video={video} index={index} />
          ))}
        </div>

        {/* No videos */}
        {filteredVideos.length === 0 && (
          <div className="text-center py-20">
            <div className="text-6xl mb-4">🕹️</div>
            <p className="text-gray-600 text-lg">
              Іздеу бойынша еркін ойындар табылмады
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErkinOiyn;
